<i class="fas {{ name }}"></i>
